'use strict';

const Mn = require('backbone.marionette');
const pdfjsLib = require('pdfjs-dist/es5/build/pdf.js') ;
const pdfjsWorkerEntry = require('pdfjs-dist/es5/build/pdf.worker.entry.js');
const StorageAPI = require('data/infra/api/storage/index');
const Template = require('data/ui/template/content/pdf-previewer.hbs');

/**
 * PDF の DataContentVersion を元に PDF をプレビュー表示する
 */
module.exports = Mn.View.extend({
    template: Template,
    ui: {
        preview: '.pdf-preview-content',
        showMoreButton: '.show-more',
    },
    events: {
        'click @ui.showMoreButton': 'showMore'
    },
    initialize: function() {
        if (!this.model.isPDF()) {
            throw new Error(`Not PDF Content: ${this.model.getMetaData().getContentType()}`);
        }

        const storageObjectId = this.model.getDataSource().getStorageObjectId();
        const project = this.model.getContent().getProject();
        this.pdfURI = (project && storageObjectId) ?
            StorageAPI.getDownloadURL(project.id, storageObjectId) : null;

        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorkerEntry;
        this.maxPage = 3;
        this.pdf = null;
        this.currentPage = null;
        _.bindAll(this, 'renderPageRecursive');
    },

    onDomRefresh: function() {
        const loadingTask = pdfjsLib.getDocument(this.pdfURI);
        loadingTask.promise.then((pdf) => {
            this.pdf = pdf;
            this.toggelShowMoreButton();
            this.pdf.getPage(1).then(this.renderPageRecursive);
        });
    },

    getViewPort: function(page) {
        var viewport = page.getViewport({ scale: 1 });
        const w = this.ui.preview.width();
        const scale = w / viewport.width * 0.9;
        return page.getViewport({ scale: scale });
    },

    renderPageRecursive: function(page) {
        this.currentPage = page;
        const viewport = this.getViewPort(page);
        const canvas = document.createElement('canvas');
        canvas.style.display = 'inline-block';
        canvas.style.margin = '8px 0';
        canvas.style.border = 'solid 1px #aaa';

        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        //Draw it on the canvas
        page.render({canvasContext: context, viewport: viewport});

        //Add it to the web page
        this.ui.preview.append( canvas );

        if ( page.pageNumber < this.maxPage && page.pageNumber < this.pdf.numPages )
        {
            this.pdf.getPage( page.pageNumber + 1 ).then(this.renderPageRecursive);
        }
    },

    showMore() {
        this.maxPage += 1000;
        this.toggelShowMoreButton();
        this.pdf.getPage( this.currentPage.pageNumber + 1 ).then(this.renderPageRecursive);
    },

    toggelShowMoreButton() {
        if (this.maxPage > this.pdf.numPages) {
            this.ui.showMoreButton.hide();
        } else {
            this.ui.showMoreButton.show();
        }
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/content/pdf-previewer.js